export function flow(type, events, layer) {
  if (layer === 0 && this.leftRef.current) {
    this.leftRef.current.flow(type, events, layer)
  } else if (this.rightRef.current) {
    this.rightRef.current.flow(type, events, layer)
  }
}

export function setEl(el) {
  if (typeof el.get == 'function') {
    this.el = el.get(0)
  } else {
    this.el = el
  }

  if (typeof $ !== 'undefined') {
    this.$el = $(el)
  }

  return this
}

export function destroy() {
  if (this.chart) {
    if (typeof this.clear === 'function') {
      this.clear()
    }
    this.chart.destroy()
    this.chart = {}
  }
}